import { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import CustomButton from "../CustomButton/CustomButton";
import { Select } from "../../components/Base/Select";
import {
  getCustodiansForFilter,
  getMasterAccounts,
  addMasterAccountToAdvisor,
  removeMasterAccounts,
  resetMasterAccounts,
} from "../../redux/actions";
import { emailRegex } from "../../Regex";

const Wrapper = styled.div`
  width: 100%;
  padding: 20px 0px;
  /* max-height: 300px;
  overflow: auto; */

  .masterAccountRow {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 10px;

    .dropDownContainer {
      text-align: left;
      width: 30%;
    }

    .textBoxContainer {
      text-align: left;
      width: 35%;
    }

    .buttonContainer {
      width: 35%;
      text-align: right;
    }
  }
`;

const LinkedAccounts = ({
  email,
  onMasterAccountStateUpdate,
  preLoadedMasterAccounts = [],
  advisorId,
  masterAccountIdProps,
}) => {
  const dispatch = useDispatch();
  const [masterAccountsState, setMasterAccountsState] = useState([]);
  const [selectedCustodian, setSelectedCustodian] = useState("");
  const [advisorNumber, setAdvisorNumber] = useState("");
  const { custodianForFilter, masterAccounts } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    dispatch(getCustodiansForFilter());
  }, []);

  useEffect(() => {
    if (!emailRegex.test(email)) return;

    const timeoutId = setTimeout(() => {
      dispatch(getMasterAccounts(email));
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [email]);

  useEffect(() => {
    if (preLoadedMasterAccounts.length)
      setMasterAccountsState([...preLoadedMasterAccounts]);
  }, [preLoadedMasterAccounts]);

  useEffect(() => {
    if (masterAccounts?.length)
      setMasterAccountsState([...masterAccounts, ...masterAccountsState]);
  }, [masterAccounts]);

  useEffect(() => {
    return () => {
      dispatch(resetMasterAccounts());
    };
  }, []);

  const handleMasterAccountDelete = (masterACcountId) => {
    let temp = [...masterAccountsState];
    temp.splice(
      temp.findIndex((a) => a.masterAccountId === masterACcountId),
      1
    );
    setMasterAccountsState(temp);

    if (advisorId) dispatch(removeMasterAccounts(masterACcountId));
  };

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    setAdvisorNumber(value);
  };

  useEffect(() => {
    onMasterAccountStateUpdate(masterAccountsState);
  }, [masterAccountsState]);

  const handleMasterAccoundAdd = () => {
    if (!selectedCustodian || !advisorNumber) return;

    if (selectedCustodian && advisorNumber && !advisorId) {
      let temp = [...masterAccountsState];
      temp.push({
        custodianId: selectedCustodian,
        masterAccountNumber: advisorNumber,
      });
      setMasterAccountsState(temp);
    }

    if (advisorId) {
      dispatch(
        addMasterAccountToAdvisor({
          masterAccount: {
            custodianId: selectedCustodian,
            masterAccountNumber: advisorNumber,
          },
          advisorId: advisorId,
        })
      );
    }
    setSelectedCustodian("");
    setAdvisorNumber("");
  };

  return (
    <Wrapper>
      <div className="masterAccountRow">
        <div className="dropDownContainer">
          <Select
            options={
              (custodianForFilter?.length &&
                custodianForFilter?.map((state) => ({
                  label: `${state.name}`,
                  value: `${state.id}`,
                }))) ||
              []
            }
            defaultValue={selectedCustodian}
            onChange={(option) => {
              setSelectedCustodian(option);
            }}
            label="Choose Custodian"
            placeholder="Choose Custodian"
            key={1}
          />
        </div>
        <div className="textBoxContainer">
          <CustomTextBox
            placeholder="Advisor Number"
            errorMessage=""
            value={advisorNumber}
            disabled={false}
            name="advisorNumber"
            onBlur={handleCustomTextBoxOnBlur}
          />
        </div>
        <div className="buttonContainer">
          <CustomButton text={"Add"} onClick={handleMasterAccoundAdd} />
        </div>
      </div>
      {masterAccountsState?.map((data) => (
        <div className="masterAccountRow">
          <div className="dropDownContainer">
            <Select
              options={
                (custodianForFilter?.length &&
                  custodianForFilter?.map((state) => ({
                    label: `${state.name}`,
                    value: `${state.id}`,
                  }))) ||
                []
              }
              disabled={true}
              defaultValue={
                data?.custodianId ||
                custodianForFilter.find(
                  (data1) => data1?.name === data?.custodianName
                )?.id
              }
              onChange={() => {}}
              key={1}
            />
          </div>
          <div className="textBoxContainer">
            <CustomTextBox
              placeholder="Advisor Number"
              errorMessage=""
              value={data?.masterAccountNumber}
              disabled={true}
              name="advisorNumber"
              onBlur={() => {}}
              onKeyPress={() => {}}
            />
          </div>
          <div className="buttonContainer">
            <CustomButton
              text={"Remove"}
              onClick={() => {
                handleMasterAccountDelete(data?.id);
              }}
            />
          </div>
        </div>
      ))}
    </Wrapper>
  );
};

export default LinkedAccounts;
